import {IParams, RecursosController} from "../recursos";
import {EventManager} from "./event-manager";

declare global {
    interface Window {
        dailymotion: any;
        subtipologia: string;
        listaKeyValuesTexto: string;
    }
}

export class DailymotionControllerVideoNoticia extends RecursosController {

    /* INSTANCE */
    public static instance: DailymotionControllerVideoNoticia;

    /* STATIC */
    public static override async build(): Promise<void> {
        DailymotionControllerVideoNoticia.instance = new this();
    }

    constructor() {
        super();
        this.load();
    }

    protected async load(): Promise<void> {
        const id = document.querySelector('.player-dm')?.id;
        if (id) {
            const urls: IParams[] = [{name: "script-dailymotion-x12jwy", value: "https://geo.dailymotion.com/libs/player/x12jwy.js"}];
            const promesas = await this.initPromises(urls);

            await Promise.all(promesas).then(async()=>{
                if (!window.hbError) {
                    const eventId = "prerollKv" + id;
                    const em = EventManager.build();
                    em.addId(eventId);

                    const listener = (e: Event) => {
                        const customEvent = e as CustomEvent;
                        if (customEvent.detail) {
                            this.loadVideo(id, customEvent.detail?.kv);
                        }
                        document.removeEventListener(eventId, listener);
                    };

                    document.addEventListener(eventId, listener, { once: true });

                    window.alpred.hb.refreshById(["preroll"]);
                } else {
                    this.loadVideo(id, "");
                }
            });
        }
    }

    protected async loadVideo(id: string, kvPrebid: string): Promise<void> {
        const config: any = {
            params: {
                customConfig: {
                    dynamiciu: "/151127700/video",
                    keyvalues: 'subtipologia='+window.subtipologia+'&position=head'+ (kvPrebid.length > 0?kvPrebid:''),
                    plcmt: 2
                }
            }
        };

        config.video = id;
        config.player = 'x12jwy';
        config.mute = true;

        await window.dailymotion.createPlayer(id, config).catch(function(e: any) {
            console.error(e);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        //
    }

}
